module.exports = __webpack_public_path__ + "img/mammography-cuate.d59b3465.svg";